import { useSuspenseQuery } from "@tanstack/react-query";
import {
  createFileRoute,
  useNavigate,
} from "@tanstack/react-router";
import { useState } from "react";

import { useTRPC } from "@/infrastructure/trpc/react";

export const Route = createFileRoute(
  "/app/speech-agent/historie/"
)({
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.prefetchQuery(
        context.trpc.speechAgent.conversations.list.queryOptions(
          {
            q: "",
            tag: "",
          }
        )
      ),
      context.queryClient.prefetchQuery(
        context.trpc.speechAgent.conversations.tags.queryOptions()
      ),
    ]);
  },
  component: HistoryPage,
});

const formatDate = (d: Date): string => {
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${dd}.${mm}.${yyyy} ${hh}:${mi}`;
};

function HistoryPage() {
  const trpc = useTRPC();
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [tagFilter, setTagFilter] = useState("");

  const { data: rows, refetch } = useSuspenseQuery(
    trpc.speechAgent.conversations.list.queryOptions({
      q: query,
      tag: tagFilter,
    })
  );

  const { data: tags } = useSuspenseQuery(
    trpc.speechAgent.conversations.tags.queryOptions()
  );

  return (
    <section className="page" id="page-historie">
      <div className="card list-card">
        <div className="card-head">
          <p className="kicker">— Archiv</p>
          <h2 className="card-title">
            Historie konverzací
          </h2>
          <div className="card-actions">
            <button
              type="button"
              className="ghost-btn"
              onClick={() => void refetch()}
            >
              Obnovit
            </button>
          </div>
        </div>
        <div className="historie-filter">
          <input
            type="search"
            placeholder="Hledat v zápisech…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            autoComplete="off"
          />
          {tags.length > 0 && (
            <div
              className="tag-chip-row"
              aria-label="Filtr podle štítků"
            >
              <button
                type="button"
                className={`tag-chip${tagFilter === "" ? " active" : ""}`}
                onClick={() => setTagFilter("")}
              >
                Vše
              </button>
              {tags.map((t) => (
                <button
                  key={t.tag}
                  type="button"
                  className={`tag-chip${tagFilter === t.tag ? " active" : ""}`}
                  onClick={() =>
                    setTagFilter(
                      tagFilter === t.tag ? "" : t.tag
                    )
                  }
                >
                  {t.tag} ({t.count})
                </button>
              ))}
            </div>
          )}
        </div>
        {rows.length === 0 ? (
          <p className="status">Zatím žádné konverzace.</p>
        ) : (
          <ul className="historie-list list">
            {rows.map((r) => (
              <li key={r.id} className="historie-item">
                <div className="historie-item-main">
                  <p className="historie-item-title">
                    {r.title ?? "(bez názvu)"}
                  </p>
                  <p className="historie-item-meta">
                    {r.agentId} ·{" "}
                    {formatDate(new Date(r.startedAt))} ·{" "}
                    {r.status === "finalized"
                      ? "dokončeno"
                      : "rozpracováno"}
                    {r.uploaded ? " · nahráno" : ""}
                    {r.tags.length > 0
                      ? ` · ${r.tags.join(", ")}`
                      : ""}
                  </p>
                </div>
                <div className="item-actions">
                  <button
                    type="button"
                    onClick={() =>
                      void navigate({
                        to: "/app/speech-agent/historie/$id",
                        params: { id: r.id },
                      })
                    }
                  >
                    Otevřít
                  </button>
                  {r.status === "finalized" && (
                    <button
                      type="button"
                      onClick={() => {
                        window.location.href = `/api/conversations/${r.id}/pdf`;
                      }}
                    >
                      PDF
                    </button>
                  )}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
